import {DEFAULT_COLUMN_WIDTH} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';

export default function toColumnWidth({
  columnType,
  width,
}: {
  columnType: TableColumnType;
  width?: number | null;
}): number {
  if (width != null) {
    return width;
  }

  switch (columnType) {
    case TableColumnType.CONCENTRATION:
    case TableColumnType.CONTAINERS:
    case TableColumnType.NUMBER_OF_CONTAINERS:
    case TableColumnType.PARENT_STORABLE:
    case TableColumnType.PROCEDURE_CONDITION_REPLICATES:
      return DEFAULT_COLUMN_WIDTH + 50;
    default:
      return DEFAULT_COLUMN_WIDTH;
  }
}
